module.exports = __webpack_public_path__ + "img/wallet.e4aa5045.svg";